import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
  ViewTableModule,
  AutocompleteModule,
  ComboModule,
  DaterangepickerModule,
  InputModule,
  CustomModalModule,
} from 'beyond-util';
import {
  CalendarDayModule,
  CalendarModule,
  CalendarMonthModule,
  CalendarWeekModule,
} from 'angular-calendar';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlatpickrModule } from 'angularx-flatpickr';

import { MontazaComponent } from './montaza.component';
import { PregledDanaDetailsComponent } from '../../components/montaza/pregled-dana-details/pregled-dana-details.component';
import { UredjivanjeDetailsComponent } from '../../components/montaza/uredjivanje-details/uredjivanje-details.component';
import { MontazaDetailsComponent } from '../../components/montaza/montaza-details/montaza-details.component';
import { EmisijaDetailsComponent } from '../../components/emisija-details/emisija-details.component';
import { MontazaKalendarModule } from '../../components/montaza/montaza-kalendar/montaza-kalendar.module';

@NgModule({
  declarations: [
    MontazaComponent,
    PregledDanaDetailsComponent,
    UredjivanjeDetailsComponent,
    MontazaDetailsComponent,
    EmisijaDetailsComponent,
  ],
  entryComponents: [
    MontazaComponent,
    PregledDanaDetailsComponent,
    UredjivanjeDetailsComponent,
    MontazaDetailsComponent,
    EmisijaDetailsComponent,
  ],
  exports: [
    MontazaComponent,
    PregledDanaDetailsComponent,
    UredjivanjeDetailsComponent,
    MontazaDetailsComponent,
    EmisijaDetailsComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    ViewTableModule,
    AutocompleteModule,
    ComboModule,
    DaterangepickerModule,
    InputModule,
    TooltipModule,
    CalendarMonthModule,
    CalendarWeekModule,
    CalendarDayModule,
    BrowserAnimationsModule,
    CustomModalModule,
    MontazaKalendarModule,
    NgxSpinnerModule,
  ],
})
export class MontazaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/montaza/montaza.module.ts